import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { OrganisationTypeConstants, ProjectGroupConstants } from "../../../../../../constants";
import { Origin } from "../../../../../../models";
import { GetGroupDetailsResponse, GetProjectDetailsResponse } from "../../../../../../service/query";
import { ServiceError } from "../../../../../../service/Shared";
import { useAuth } from "../../../../../../useAuth";
import {
  getActivitiesRoute,
  getDashboardRoute,
  getLandholdingDashboardRoute,
  getProjectAuditHistoryRoute,
  getProjectDetailsByUuid,
  getSettingsAuditHistoryRoute,
} from "../../../../../../utils/routes";
import { GroupContext } from "./GroupContext";

interface UseManageProjectGroupReturnData {
  groupDetails?: GetGroupDetailsResponse;
  projectDetails?: GetProjectDetailsResponse;
  currentUserType: OrganisationTypeConstants;
  backButtonText: string;
  errors: ServiceError[] | undefined;
  isLandholdingManagement: boolean;
  handleBackClick: () => void;
}

export const useManageProjectGroup = (): UseManageProjectGroupReturnData => {
  const navigate = useNavigate();
  const { currentUserType } = useAuth();

  const { groupDetails, groupType, origin, currentProjectUuid, errors } = useContext(GroupContext);
  const isLandholdingManagement = groupType === ProjectGroupConstants.GROUP_TYPE_LANDHOLDING;

  let backButtonText: string;
  let route: string;
  switch (origin) {
    case Origin.LandholdingDetailsPage:
      route = getLandholdingDashboardRoute(groupDetails?.groupGuid || "", currentUserType);
      backButtonText = "Back to landholding";
      break;
    case Origin.ProjectAuditPage:
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      route = getProjectAuditHistoryRoute(currentProjectUuid!, currentUserType);
      backButtonText = "Back to audit";
      break;
    case Origin.OrganisationAuditPage:
      route = getSettingsAuditHistoryRoute(currentUserType);
      backButtonText = "Back to audit";
      break;
    case Origin.DeveloperDashboardPage:
      route = getDashboardRoute(OrganisationTypeConstants.DEVELOPER);
      backButtonText = "Back to dashboard";
      break;
    case Origin.DeveloperActivitiesPage:
      route = getActivitiesRoute(OrganisationTypeConstants.DEVELOPER);
      backButtonText = "Back to activities";
      break;
    default:
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      route = getProjectDetailsByUuid(currentProjectUuid!, OrganisationTypeConstants.DEVELOPER);
      backButtonText = "Back to project";
      break;
  }

  const handleBackClick = (): void => {
    navigate(route);
  };

  return {
    groupDetails,
    currentUserType,
    backButtonText,
    errors,
    isLandholdingManagement,
    handleBackClick,
  };
};
